/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PremiumDueResponseDto
 */
export interface PremiumDueResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    broker?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    reinsured?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    insured?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    binder?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    pinnacleRefNo?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    premiumStatus: PremiumDueResponseDtoPremiumStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    currency?: PremiumDueResponseDtoCurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    netAmountDueFromBroker: string;
    /**
     * 
     * @type {Date}
     * @memberof PremiumDueResponseDto
     */
    ppwDueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof PremiumDueResponseDto
     */
    inceptionDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PremiumDueResponseDto
     */
    expiryDate?: Date;
    /**
     * Premium closing check
     * @type {boolean}
     * @memberof PremiumDueResponseDto
     */
    closing?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    contractId: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    nocStatus: PremiumDueResponseDtoNocStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof PremiumDueResponseDto
     */
    premiumScheduleId: string;
}


/**
 * @export
 */
export const PremiumDueResponseDtoPremiumStatusEnum = {
    Current: 'Current',
    Overdue30Days: 'overdue_30_days',
    Overdue60Days: 'overdue_60_days',
    Overdue90Days: 'overdue_90_days',
    OverdueMoreThan90Days: 'overdue_more_than_90_days',
    Paid: 'Paid'
} as const;
export type PremiumDueResponseDtoPremiumStatusEnum = typeof PremiumDueResponseDtoPremiumStatusEnum[keyof typeof PremiumDueResponseDtoPremiumStatusEnum];

/**
 * @export
 */
export const PremiumDueResponseDtoCurrencyEnum = {
    Aud: 'AUD',
    Usd: 'USD',
    Nzd: 'NZD'
} as const;
export type PremiumDueResponseDtoCurrencyEnum = typeof PremiumDueResponseDtoCurrencyEnum[keyof typeof PremiumDueResponseDtoCurrencyEnum];

/**
 * @export
 */
export const PremiumDueResponseDtoNocStatusEnum = {
    NocDue: 'NOC Due',
    NocIssued: 'NOC Issued',
    Paid: 'Paid',
    Cancelled: 'Cancelled',
    ExtensionGranted: 'Extension Granted'
} as const;
export type PremiumDueResponseDtoNocStatusEnum = typeof PremiumDueResponseDtoNocStatusEnum[keyof typeof PremiumDueResponseDtoNocStatusEnum];


/**
 * Check if a given object implements the PremiumDueResponseDto interface.
 */
export function instanceOfPremiumDueResponseDto(value: object): value is PremiumDueResponseDto {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('premiumStatus' in value) || value['premiumStatus'] === undefined) return false;
    if (!('netAmountDueFromBroker' in value) || value['netAmountDueFromBroker'] === undefined) return false;
    if (!('ppwDueDate' in value) || value['ppwDueDate'] === undefined) return false;
    if (!('contractId' in value) || value['contractId'] === undefined) return false;
    if (!('nocStatus' in value) || value['nocStatus'] === undefined) return false;
    if (!('premiumScheduleId' in value) || value['premiumScheduleId'] === undefined) return false;
    return true;
}

export function PremiumDueResponseDtoFromJSON(json: any): PremiumDueResponseDto {
    return PremiumDueResponseDtoFromJSONTyped(json, false);
}

export function PremiumDueResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PremiumDueResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'broker': json['broker'] == null ? undefined : json['broker'],
        'reinsured': json['reinsured'] == null ? undefined : json['reinsured'],
        'insured': json['insured'] == null ? undefined : json['insured'],
        'binder': json['binder'] == null ? undefined : json['binder'],
        'pinnacleRefNo': json['pinnacleRefNo'] == null ? undefined : json['pinnacleRefNo'],
        'description': json['description'],
        'premiumStatus': json['premiumStatus'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'netAmountDueFromBroker': json['netAmountDueFromBroker'],
        'ppwDueDate': (new Date(json['ppwDueDate'])),
        'inceptionDate': json['inceptionDate'] == null ? undefined : (new Date(json['inceptionDate'])),
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'closing': json['closing'] == null ? undefined : json['closing'],
        'contractId': json['contractId'],
        'nocStatus': json['nocStatus'],
        'premiumScheduleId': json['premiumScheduleId'],
    };
}

export function PremiumDueResponseDtoToJSON(json: any): PremiumDueResponseDto {
    return PremiumDueResponseDtoToJSONTyped(json, false);
}

export function PremiumDueResponseDtoToJSONTyped(value?: PremiumDueResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'broker': value['broker'],
        'reinsured': value['reinsured'],
        'insured': value['insured'],
        'binder': value['binder'],
        'pinnacleRefNo': value['pinnacleRefNo'],
        'description': value['description'],
        'premiumStatus': value['premiumStatus'],
        'currency': value['currency'],
        'netAmountDueFromBroker': value['netAmountDueFromBroker'],
        'ppwDueDate': ((value['ppwDueDate']).toISOString()),
        'inceptionDate': value['inceptionDate'] == null ? undefined : ((value['inceptionDate']).toISOString()),
        'expiryDate': value['expiryDate'] == null ? undefined : ((value['expiryDate']).toISOString()),
        'closing': value['closing'],
        'contractId': value['contractId'],
        'nocStatus': value['nocStatus'],
        'premiumScheduleId': value['premiumScheduleId'],
    };
}

